module.exports = __webpack_public_path__ + "images/category_lp/macbook/store_images/5_36303e7a2f2dbed1e991346ba95f4c95.png";